import type { LexicalEditor } from 'lexical';

import type { LanguageEnum } from 'js/src/client';

export const TRANSLATED_EDITORS_ACTIONS = {
    STORE_TRANSLATED_EDITORS: 'STORE_TRANSLATED_EDITORS',
    STORE_TRANSLATED_EDITOR: 'STORE_TRANSLATED_EDITOR',
    REMOVE_TRANSLATED_EDITOR: 'REMOVE_TRANSLATED_EDITOR',
    STORE_ACTIVE_TRANSLATION_SCENE_GROUP_ID: 'STORE_ACTIVE_TRANSLATION_SCENE_GROUP_ID',
    CLEAR_ACTIVE_TRANSLATION_SCENE_GROUP_ID: 'CLEAR_ACTIVE_TRANSLATION_SCENE_GROUP_ID',
    HYDRATE_TRANSLATED_TRANSCRIPTS_FROM_REDUX: 'HYDRATE_TRANSLATED_TRANSCRIPTS_FROM_REDUX',
};

/** TYPESCRIPT TYPES */
type LexicalEditorsData = Readonly<{
    editor: LexicalEditor;
    lexicalControlsItsOwnState: boolean;
}>;
export type TranscriptTranslationsType = Readonly<Record<LanguageEnum, LexicalEditorsData>>;
export type TranslatedEditorsType = Readonly<{
    sceneGroupId: string;
    translations: TranscriptTranslationsType;
}>;
